import { Box } from "@mui/material";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { caseManagementUrl } from "../../../../config";
import FileInstructionsForm from "./Form";
import { FileInstructionsColumns } from "../../../../data/DynamicTable/Collumns";

const base_url = caseManagementUrl.uri;
const actions = {
  entity: "File Instructions",
  isSubRight: false,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: false,
    permission: "EditPermission",
  },
  RemoveItem: {
    key: "VIEWDETAILS",
    button_name: "Remove Instruction",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
    modelName: "FileInstructions",
    inputObjectName: "activateDeactivateFileInstruction"
  },
  add: {
    key: "New File Instruction",
    button_name: "New File Instruction",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },
  ViewCase: {
    key: "VIEWDETAILS",
    button_name: "View Details",
    Show_Button: false,
  },
  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },
  showStatus: true,
  dataObject: {
    inputObjectName: "fileInstructionsViewsByColumnValues",
    inputSubObjectName: "viewModel",
    returnFields: [
      "id",
      "postDate",
      "sender",
      "receiver",
      "details",
      "amount",
      "client",
      "file",
      "approvedBy",
      "status"
    ],
  },
};
function FileInstructions() {
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="File Instructions"
          subtitle="View all File Instructions, create or edit "
          columns={FileInstructionsColumns}
          FormComponent={FileInstructionsForm}
          actions={actions}
          base_url={base_url}
        />
      </>
    </Box>
  );
}

export default FileInstructions;